import React from 'react'
import Markdown from 'react-markdown'
import { withProps } from 'recompose'

import { getAboutContent, getFeedbackCfg } from '../app/selectors'
import content from '../content'
import Feedback from '../addons/feedback/Feedback'

const AboutPage = ({ text, gallery, feedbackCfg }) => (
  <div>
    <Markdown source={text} />
    <Feedback cfg={feedbackCfg} />
  </div>
)

const aboutContent = getAboutContent(content)
const feedbackCfg = getFeedbackCfg(content)

const withPageContent = withProps({
  text: aboutContent.text,
  feedbackCfg,
})

export default withPageContent(AboutPage)



// WEBPACK FOOTER //
// ./src/containers/AboutPage.js